import { add } from 'lodash';
import { version } from 'os';
import { report } from 'process';
import { createI18n } from 'vue-i18n';

const i18n = createI18n({
    legacy: false,
    locale: "pt",
    globalInjection: true,
    messages: {
        en: {
            message: {
                start_selling: 'Start selling time',
                end_selling: 'End selling time',
                top_up_collection: 'Top-Up Collection',
                device_summary: 'Device summary',
                system_summary: 'System summary',
                backHome: "Back To Home",
                forbidden: "You don't have enough permission to this task",
                train_number: "Train Number",
                TransactionType: "Transaction Type",
                language: "English",
                change_status: "Change Status",
                dashboard: "Dashboard",
                greeting: "Hello !",
                cargo: "cargo",
                transaction: "Transaction",
                transactions: "Transactions",
                all: "all",
                showing: "showing",
                search: "search",
                of: "of",
                previous: "previous",
                next: "next",
                current: "current",
                page: "page",
                operator: "operator",
                operators: "operators",
                name: "Name",
                total: "total",
                amount: "Amount",
                weight: "weight",
                sender: "sender",
                details: "details",
                receiver: "receiver",
                from: "from",
                to: "to",
                status: "Status",
                statuses: "statuses",
                action: "action",
                //Audit Trails
                method: "method",
                ip_address: "ip address",
                endpoint: "endpoint",
                username: "user name",
                activity: "activity",
                audit: "audit",
                trail: "trail",
                trails: "trails",
                user: "user",
                users: "users",
                actor: "actor",
                actors: "actors",
                browser: "browser",
                date: "Date",
                add: "add",
                customer: "Customer",
                category: "Category",
                categories: "categories",
                sub_category: "subcategory",
                sub_categories: "subcategories",
                are: "are",
                you: "you",
                sure: "sure",
                do_you_really_want_to: "do you really want to",
                delete: "delete",
                confirm: "confirm",
                submit: "Submit",
                cancel: "cancel",
                tracking: "tracking",
                this: "this",
                record: "record",
                next_status_name: "next status name",
                receipt_number: "receipt number",
                reference_number: "reference number",
                purchase: "purchase",
                phone: "phone",
                number: "number",
                price: "price",
                measurement: "measurement",
                kg: "kg",
                meticals: "meticals",
                payment: "payment",
                shipping: "shipping",
                information: "information",
                info: "info",
                quantity: "quantity",
                item: "item",
                order: "order",
                print: "print",
                PDF: "PDF",
                export: "export",
                device: "device",
                ID: "ID",
                serial: "serial",
                model: "model",
                type: "type",
                types: "types",
                sources: "sources",
                manufacture: "manufacture",
                manufactures: "manufactures",
                wagon: "wagon",
                wagons: "wagons",
                seat: "seat",
                seats: "seats",
                configuration: "configuration",
                configurations: "configurations",
                standing: "standing",
                train: "Train",
                trains: "Trains",
                class: "Class",
                classes: "classes",
                select: "select",
                normal: "normal",
                cabin: "cabin",
                cabins: "cabins",
                label: "label",
                serial_number: "serial number",
                wagon_type: "wagon type",
                layout: "layout",
                layouts: "layouts",
                complete: "complete",
                criteria: "criteria",
                criterias: "criterias",
                report: "report",
                module: "module",
                aisle: "aisle",
                rows: "rows",
                row: "row",
                incentives: "incentives",
                mode: "mode",
                rate: "rate",
                flat_amount: "flat amount",
                percentage: "percentage",
                summary: "summary",
                tickets: "tickets",
                ticket: "ticket",
                collected: "collected",
                time: "time",
                on_train: "on train",
                off_train: "off train",
                file: "file",
                excel: "Excel",
                csv: "CSV",
                txt: "txt",
                notifications: "notifications",
                profile: "profile",
                reset: "reset",
                password: "password",
                help: "help",
                logout: "logout",
                cash: "cash",
                ascending: "ascending",
                descending: "descending",
                asc: "asc",
                desc: "desc",
                count: "count",
                top: "top",
                up: "up",
                collection: "collection",
                start: "start",
                end: "end",
                for: "for",
                uncollected: "uncollected",
                approval: "approval",
                processes: "processes",
                pending: "pending",
                approve: "approve",
                approved: "approved",
                reject: "reject",
                rejected: "rejected",
                on: "on",
                on_progress: "on progress",
                level: "level",
                created_at: "created at",
                updated_at: "updated at",
                initiator: "initiator",
                last: "last",
                process: "process",
                comment: "comment",
                logs: "logs",
                received: "received",
                manual: "manual",
                slots: "slots",
                coaches: "coaches",
                coach: "coach",
                schedule: "schedule",
                schedules: "schedules",
                departure: "departure",
                destination: "destination",
                station: "station",
                stations: "stations",
                dep: "dep",
                dest: "dest",
                day_of_the_week: "day of the week",
                trip_duration_hours: "trip duration hours",
                trip_duration: "trip duration",
                the: "the",
                week: "week",
                monday: "monday",
                tuesday: "tuesday",
                wednesday: "wednesday",
                thursday: "thursday",
                friday: "friday",
                saturday: "saturday",
                sunday: "sunday",
                day: "day",
                days: "days",
                edit: "edit",
                today: "today",
                new: "new",
                paid: "paid",
                list: "list",
                arrangement: "arrangement",
                column: "column",
                columns: "columns",
                hours: "hours",
                system: "System",
                physical: "physical",
                any: "any",
                print_out: "print out",
                active: "active",
                inactive: "inactive",
                full: "full",
                contact: "contact",
                blocked: "blocked",
                line: "line",
                lines: "lines",
                customers: "Customers",
                km: "km",
                range: "range",
                prices: "prices",
                upload: "upload",
                assign: "assign",
                reassign: "reassign",
                actions: "actions",
                account: "account",
                accounts: "accounts",
                contacts: "contacts",
                news: "news",
                updates: "updates",
                content: "content",
                platform: "platform",
                title: "title",
                POS: "POS",
                kiosk: "kiosk",
                application: "application",
                flow: "flow",
                sequence: "sequence",
                zones: "zones",
                zone: "zone",
                route: "Route",
                routes: "routes",
                old: "old",
                card: "card",
                cards: "cards",
                ownership: "ownership",
                owner: "owner",
                expire: "expire",
                uploded: "uploded",
                package: "package",
                gender: "gender",
                identification: "identification",
                registration: "registration",
                first: "first",
                middle: "middle",
                usage: "usage",
                code: "code",
                balance: "balance",
                minimum: "minimum",
                sale: "sale",
                send: "send",
                per: "per",
                debit: "debit",
                field: "field",
                discount: "discount",
                group: "group",
                special: "special",
                main: "main",
                expired: "expired",
                five: "five",
                digits: "digits",
                arrival: "arrival",
                direction: "direction",
                support: "support",
                second: "second",
                third: "third",
                one: "one",
                two: "two",
                three: "three",
                reverse: "reverse",
                male: "male",
                female: "female",
                reason: "reason",
                fine: "fine",
                change: "change",
                receipt: "receipt",
                charge: "charge",
                valid: "valid",
                failed: "failed",
                phc: "phc",
                back: "back",
                cancelled_at: "Cancelled at",
                cancelled_by: "Cancelled by",
                validation_status: "Validation Status",
                contract: "contract",
                institution: "institution",
                packages: "packages",
                cancellation: "cancellation",
                no_train_details: "No train details",
                top_up_transaction: "top up transaction",
                top_up: "top up",
                "suspicious": "suspicious",
                adjustment: "adjustment",
                statement: "statement",
                credit: "credit",
                adjustment_transaction_type: "Balance Adjustment (CR / DR)",
                no_customer_record: "No customer record",
                cancel_multiple_transactions: "Cancel multiple transactions",
                no: "no",
                data: "data",
                email: "email",
                choose: "choose",
                passport: "passport",
                message: "message",
                pin: "pin",
                description: "description",
                trend: "trend",
                employee_incentive: "Employee incentive",
                customer_name: "customer name",
                Employee_ID: "Employee ID",
                agent: "agent",
                month: "month",
                menu: {
                    dashboard: "Dashboard",
                    management: "Configurations",
                    trainClasses: "Train Classes",
                    trainLines: "Train Lines",
                    trainRoutes: "Train Routes",
                    stations: "Stations",
                    trains: "Trains",
                    todayTrains: "Today Trains",
                    prices: "Prices",
                    stationSchedules: "Station Schedules",
                    zones: "Zones",
                    cardManagement: "Card Management",
                    cards: "Cards",
                    cardStatement: "Card Statement",
                    balanceAdjustment: "Balance Adjustment",
                    adjustmentApproval: "Adjustment Approval",
                    customerManagement: "Customer Management",
                    customers: "Customers",
                    customerAccounts: "Customer Accounts",
                    contractInstitutions: "Contract Institutions",
                    accountPackages: "Account Packages",
                    employeeIncentive: "Employee Incentive",
                    transactionManagement: "Transaction Management",
                    transactions: "Transactions",
                    cancelApproval: "Cancel Approval",
                    adjustmentTransactions: "Adjustment Transactions",
                    devices: "Devices",
                    validation: "Validation",
                    suspiciousReport: "Suspicious Report",
                    trainCapacity: "Train Capacity",
                    collections: "Collections",
                    collectionApproval: "Collection Approval",
                    operatorAccounts: "Operator Accounts",
                    m10Summary: "M10 Summary",
                    cargo: "Cargo",
                    cargoCustomers: "Customers",
                    cargoTransactions: "Cargo Transactions",
                    cargoConfigurations: "Cargo Configurations",
                    cargoPrices: "Cargo prices",
                    reports: "Reports",
                    moduleReports: "Module Reports",
                    users: "Users",
                    systemUsers: "System Users",
                    rolesPermissions: "Roles & Permissions",
                    trainSchedules: "Train Schedules",
                    trainSetup: "Train Setup",
                    coachManufactures: "Coach Manufactures",
                    coachLayouts: "Coach Layouts",
                    coaches: "Coaches",
                    trainLayouts: "Train Layouts",
                    settings: "Settings",
                    specialGroup: "Special Group",
                    incentiveConfigurations: "Incentive Configurations",
                    newsUpdates: "News & Updates",
                    cfmInformation: "Cfm Information",
                    auditTrail: "Audit Trail",
                    deviceSummaryReport: "Device Summary Report",
                    train_penalty: "Train Penalty",
                },
                pay: "pay",
                company: "company",
                tax: "tax",
                service: "service",
                latest_report_request: "Latest Report Request",
                report_request: "Report Request",
                report_request_history: "Report Request History",
                active_customers: "Active Customers",
                inactive_customers: "Inactive Customers",
                cargo_customers: "Cargo Customers",
                operator_collection: "Operator Collection",
                top_up_collections: "Top up collections",
                train_collections: "Train Collections",
                all_collections: "All Collections",
                history: "History",
                sys_amount: "Sys Amount",
                sys_tickets: "Sys Tickets",
                summary_amount: "Summary Amount",
                asc_data: "Asc Data",
                created_date: "Created date",
                trips: "trips",
                total_number: "Total Number",
                total_seats: "Total Seats",
                date_time: "Date Time",
                suspicious_report: "Suspicious Report",
                address: "address",
                operator_name: "Operator Name",
                operator_id: "Operator ID",
                device_id: "Device ID",
                device_serial: "Device Serial",
                total_tickets: "Total Tickets",
                total_amount: "Total Amount",
                report_status: "Report Status",
                ticket_no: "Ticket No",
                device_management: "Device Management",
                operator_allocation: "Operator Allocation",
                device_operator: "Device Operator",
                device_name: "Device Name",
                version: " Version",
                app_version: "App Version",
                base_station: "Base Station",
                code_number: "Code Number",
                add_new_device: "Add New Device",
                add_new_customer: "Add New Customer",
                reference_no: "Reference No",
                category_name: "Category Name",
                card_number: "Card Number",
                is_employee: "Is Employee",
                registered_date: "Registered Date",
                full_name: "Full Name",
                package_code: "Package Code",
                account_type: "Account Type",
                contact_person: "Contact Person",
                expire_date: "Expire Date",
                org_name: "Org Name",
                package_name: "Package Name",
                package_description: "Package Description",
                package_amount: "Package Amount",
                package_usage: "Package Usage",
                employee_id: "Employee ID",
                card_type: "Card Type",
                account_number: "Account Number",
                rejected_approval_processes: "Rejected Approval Processes",
                approved_approval_processes: "Approved Approval Processes",
                on_progress_approval_processes: "On Progress Approval Processes",
                train_lines: "Train Lines",
                train_line: "Train Line",
                line_distance_km: "Line Distance (KM)",
                cfm_region: "CFM Region",
                train_routes: "Train Routes",
                train_route: "Train Route",
                route_name: "Route Name",
                line_name: "Line Name",
                add_train_route: "Add Train Route",
                add_new_train_route: "Add New Train Route",
                start_station: "Start Station",
                end_station: "End Station",
                choose_start_station: "Choose Start Station",
                choose_end_station: "Choose End Station",
                destination_station: "Destination Station",
                choose_destination_station: "Choose Destination Station",
                choose_line_name: "Choose Line Name",
                train_type: "Train Type",
                add_train: "Add Train",
                add_new_train: "Add New Train",
                train_name: "Train Name",
                origin_station: "Origin Station",
                train_status: "Train Status",
                travel_hours_duration: "Travel Hours Duration",
                zone_price_group: "Zone Price Group",
                train_first_class: "Train First Class",
                first_class: "First Class",
                second_class: "Second Class",
                third_class: "Third Class",
                choose_train_class: "Choose Train Class",
                choose_train_type: "Choose Train Type",
                choose_train_status: "Choose Train Status",
                choose_zone_price_group: "Choose Zone Price Group",
                select_train_line: "Select Train Line",
                select_train_route: "Select Train Route",
                select_origin_station: "Select Origin Station",
                select_destination_station: "Select Destination Station",
                select_start_station: "Select Start Station",
                select_end_station: "Select End Station",
                select_coach_layout: "Select Coach Layout",
                select_wagon_type: "Select Wagon Type",
                coach_layout: "Coach Layout",
                zone_i: "Zone I",
                zone_ii: "Zone II",
                zone_iii: "Zone III",
                zone_iv: "Zone IV",
                add_new_train_station: "Add New Train Station",
                train_stations: "Train Stations",
                station_name: "Station Name",
                distance_maputo: "Distance Maputo",
                add_train_station: "Add Train Station",
                initial_station_name: "Initial Station Name",
                distance_from_main_station: "Distance From Main Station (KM)",
                select_ascending_zone: "Select Ascending Zone",
                select_descending_zone: "Select Descending Zone",
                off_train_ticket_available: "OFF TRAIN TICKET AVAILABLE",
                add_new_zone_price: "Add New Zone Price",
                zone_price: "Zone Price",
                zone_prices: "Zone Prices",
                automotora_price: "Automotora Price",
                normal_price: "Normal Price",
                fare_cost: "Fare Cost (MT)",
                zone_name: "Zone Name",
                on_train_cost: "On Train Cost (MT)",
                add_zone_price: "Add Zone Price",
                select_class: "Select Class",
                special_group: "Special Group",
                select_special_group: "Select Special Group",
                import_excel: "Import Excel",
                choose_excel_file: "Choose Excel File",
                download_template: "Download Template",
                select_line_first: "Select a line first",
                import_processing: "Processing your file…",
                import_processing_hint: "This can take a few minutes for large sheets — feel free to leave this page, your progress is safe.",
                import_failed: "Import failed",
                try_again: "Try Again",
                import_results: "Import Results",
                rows_created: "Rows Created",
                rows_updated: "Rows Updated",
                rows_skipped: "Rows Skipped",
                select_train_group: "Select Train Group",
                off_train_cost: "Off Train Cost (MT)",
                report_history: "Report History",
                report_name: "Report Name",
                from_date: "From Date",
                to_date: "To Date",
                file_type: "File Type",
                created_by: "Created By",
                all_customers: "All Customers",
                phone_number: "Phone Number",
                other: "Other",
                customer_type: "Customer Type",
                select_customer_type: "Select Customer Type",
                payment_mode: "Payment Mode",
                select_payment_mode: "Select Payment Mode",
                customer_service_type: "Customer Service Type",
                add_customer: "Add Customer",
                add_category: "Add Category",
                "imei": "IMEI",
                "last_connect": "Last Connect",
                collected_amount: "Collected Amount",
                total_transactions: "Total Transactions",
                ascend_train: "Ascend Train",
                asc_system_amount: "Asc System Amount",
                asc_system_tickets: "Asc System Tickets",
                descend_train: "Descend Train",
                des_system_amount: "DES System Amount",
                des_system_tickets: "DES System Tickets",
                train_Collections: "Train Collections",
                current_page: "Current Page",
                incentive: "Incentive",
                train_capacity_report: "Train Capacity Report",
                train_capacity: "Train Capacity",
                edit_device: "Edit Device",
                device_type: "Device Type",
                select_device_type: "Select Device Type",
                select_device_status: "Select Device Status",
                device_status: "Device Status",
                on_off_rain: "ON-OFF TRAIN",
                application_version: "Application Version",
                device_operators: "Device Operators",
                add_new_device_operator: "Add New Device Operator",
                operator_phone: "Operator Phone",
                operator_category: "Operator Category",
                operator_allocations: "Operator Allocations",
                add_new_operator_allocation: "Add New Operator Allocation",
                normal_seats: "Normal Seats",
                standing_slots: "Standing Slots",
                total_given: "Total Given",
                choose_operator: "Choose Operator",
                edit_operator_allocation_details: "Edit Operator Allocation Details",
                save: "Save",
                edit_device_operator: "Edit Device Operator",
                user_name: "User Name",
                agent_number: "Agent Number",
                operator_email: "Operator Email",
                zone_train_sales: "Zone Train Sales",
                normal_train_sales: "Normal Train Sales",
                automotora_train_sales: "Automotora Train Sales",
                changing_class: "Changing Class",
                scan_qr: "Scan QR",
                incentives_booking: "Incentives Booking",
                operator_details: "Operator Details",
                id_number: "ID Number",
                reset_password: "Reset Password",
                add_operator_allocation: "Add Operator Allocation",
                on_off_train: "ON-OFF TRAIN",
                printer_bda: "Printer BDA",
                allowed_sales: "Allowed Sales",
                balance_vendor_id: "Balance Vendor Id",
                balance_product_id: "Balance Product Id",
                device_imei: "Device IMEI",
                transaction_with_penalty_and_fine: "Transaction with Penalty and Fine",
                cfm_classes: "CFM Classes",
                train_types: "Train Types",
                transaction_statuses: "Transaction Statuses",
                transaction_sources: "Transaction Sources",
                adjustment_types: "Adjustment Types",
                transaction_types: "Transaction Types",
                start_date: "Start Date",
                end_date: "End Date",
                no_transaction_details_related_to_this_approval: "No transaction details related to this approval!",
                transaction_details: "Transaction Details",
                approval_process_details: "Approval Process Details",
                approval_details: "Approval Details",
                last_user_comment: "Last User Comment",
                process_flow_actors: "Process Flow Actors",
                approval_logs: "Approval Logs",
                transaction_type: "Transaction Type",
                transaction_action: "Transaction Action",
                sequence_number: "Sequence Number",
                from_old: "From (Old)",
                view_card: "View Card",
                transaction_amount: "Transaction Amount",
                fine_amount: "Fine Amount",
                cancel_reason: "Cancel Reason",
                cancel_date: "Cancel Date",
                phc_ticket_code: "PHC Ticket Code",
                sent: "Sent",
                transaction_status: "Transaction Status",
                customer_details: "Customer Details",
                assign_card: "Assign Card",
                reassign_card: "Reassign Card",
                first_name: "First Name",
                last_name: "Last Name",
                registration_date: "Registration Date",
                card_details: "Card Details",
                card_view: "Card View",
                middle_name: "Middle Name",
                identification_number: "Identification Number",
                uploded_date: "Uploaded Date",
                package_trips: "Package Trips",
                package_trips_balance: "Package Trip Balance",
                all_cards: "All Cards",
                active_cards: "Active Cards",
                inactive_cards: "Inactive Cards",
                blocked_cards: "Blocked Cards",
                expired_cards: "Expired Cards",
                edit_customer_details: "Edit Customer Details",
                passport_image: "Passport Image",
                identification_image: "Identification Image",
                choose_gender: "Choose Gender",
                accounts_blocked: "Accounts Blocked",
                customer_accounts: "Customer Accounts",
                account_usage_type: "Account Usage Type",
                ccount_balance: "Account Balance",
                account_balance: "Account Balance",
                edit_account_details: "Edit Account Details",
                account_card_statement: "Account Card Statement",
                add_new: "Add New",
                view_contract_company: "View Contract Company",
                contract_number: "Contract Number",
                institution_name: "Institution Name",
                contact_person_name: "Contact Person Name",
                contact_person_email: "Contact Person Email",
                contact_person_phone: "Contact Person Phone",
                registered_name: "Registered Name",
                registered_number: "Registered Number",
                physical_address: "Physical Address",
                postal_address: "Postal Address",
                tax_number: "Tax Number",
                vat_number: "VAT Number",
                contract_validity: "Contract Validity",
                special_discount: "Special Discount",
                limit_amount: "Limit Amount",
                pay_type: "Pay Type",
                edit_contract_company: "Edit Contract Company",
                add_contract_company: "Add Contract Company",
                fax_number: "Fax Number",
                expired_date: "Expired Date",
                account_packages: "Account Packages",
                edit_account_package: "Edit Account Package",
                package_discription: "Package Discription",
                validation_type: "Validation Type",
                trip_per_day: "Trip Per Day",
                trip_per_month: "Trip Per Month",
                dept_on: "Dept On",
                check_account_balance: "Check Account Balance",
                check_date_expiry: "Check Date Expiry",
                check_trip_balance: "Check Trip Balance",
                internal: "Internal",
                discount_percent: "Discount Percentage",
                min_balance: "Min Balance",
                is_package_for_sale: "Is Package For Sale",
                package_valid: "Package Valid",
                send_to_devices: "Send to Devices",
                package_details: "Package Details",
                package_minimum_balance: "Package Minimum Balance",
                package_maximum_balance: "Package Maximum Balance",
                package_trip_validity_days: "Package Trip Validity (Days)",
                package_for_sale: "Package For Sale",
                trips_per_day: "Trips Per Day",
                trips_per_month: "Trips Per Month",
                max_balance: "Max Balance",
                debit_field_type: "Debit Field Type",
                usage_type: "Usage Type",
                discount_percentage: "Discount Percentage",
                validity_type: "Validity Type",
                new_account_package: "New Account Package",
                debit_on: "Debit On",
                edit_employee_incentive: "Edit Employee Incentive",
                last_five_digits: "Last Five Digits",
                individual: "Individual",
                upload_new_cards: "Upload New Cards",
                permissions: "Permissions",
                you_need_permission: "You need Permission: ",
                upload_new_ards: "Upload New Cards",
                choose_card_type: "Choose Card Type",
                employee_cards: "Employee Cards",
                normal_cards: "Normal Cards",
                new_cards_file: "New Cards File",
                card_template: "Card Template",
                choose_file: "Choose File",
                edit_card: "Edit Card",
                choose_card_status: "Choose Card Status",
                linked_customer_details: "Linked Customer Details",
                card_status: "Card Status",
                card_ownership: "Card Ownership",
                choose_card_ownership: "Choose Card Ownership",
                choose_company: "Choose Company",
                balance_adjustment: "Balance Adjustment",
                select_account_number: "Select Account Number",
                credit_top_up: "Credit Top Up",
                current_user: "Current User",
                approval_level: "Approval Levels",
                initiator_name: "Initiator Name",
                adjustment_details: "Adjustment Details",
                account_package: "Account Package",
                new_balance: "New Balance",
                are_you_sure: "Are you sure?",
                today_trains: "Today Trains",
                all_today_trains: "All Today Trains",
                dest_station: "Dest Station",
                dest_time: "Dest Time",
                train_total_seats: "Train Total Seats",
                coach_details: "Coach Details",
                add_coach: "Add Coach",
                coach_serial_number: "Coach Serial Number",
                coach_total_seats: "Coach Total Seats",
                new_coach: "New Coach",
                select_coach: "Select Coach",
                do_you_really_want_to_delete_this_record: "Do you really want to delete this record?",
                do_you_really_want_to_complete_this_action: "Do you really want to complete this action?",
                weekly: "Weekly",
                monthly: "Monthly",
                long_train_transactions: "Long Train Transactions",
                automotora_transactions: "Automotora Transactions",
                zone_transactions: "Zone Transactions",
                cards_transactions: "Cards Transactions",
                cargo_transactions: "Cargo Transactions",
                bus_tickets_transactions: "Bus tickets Transactions",
                highest_monthly_trains_transactions_graph: "Highest Monthly Trains Transactions Graph",
                highestMonthly_operator_collections_chart: "Highest Monthly Operator Collections Chart",
                train_capacity_graph: "Train Capacity Graph",
                suspicious_transactions: "Suspicious Transactions",
                check_report: "Check Report",
                recently_operator_transactions: "Recently Operator Transactions",
                recently_train_transactions: "Recently Train Transactions",
                tatal_transactions: "Total Transactions",
                tatal_amount: "Total Amount",
                do_not_accept_more_than_lines: "Do not Accept more than 3 lines!",
                add_class: "Add Class",
                add_edit_train_class: "Add/Edit Train Class",
                train_class: "Train Class",
                add_line: "Add Line",
                edit_line: "Edit Line",
                line_details: "Line Details",
                edit_train_line: "Edit Train Line",
                add_train_line: "Add New Train Line",
                train_line_name: "Train line name",
                distance_km: "Distance (KM)",
                do_you_really_want_to_delete_this_train: "Do you really want to delete this train?",
                continue: "Continue",
                automotora: "Automotora",
                zonal: "Zonal",
                first_group: "First Group",
                second_group: "Second Group",
                third_group: "Third Group",
                reverse_train_number: "Reverse Train Number",
                departure_day: "Departure Days",
                departure_time: "Departure Time",
                arrival_time: "Arrival Time",
                arrival_day: "Arrival Days",
                support_first_class: "Support First Class",
                support_second_class: "Support Second Class",
                support_third_class: "Support Third Class",
                support_zone_one: "Support Zone One",
                support_zone_two: "Support Zone Two",
                support_zone_three: "Support Zone Three",
                support_zone_four: "Support Zone Four",
                route_direction: "Route Direction",
                operational: "Operational",
                edit_train_details: "Edit Train Details",
                automotra: "Automotora",
                reverse_train: "Reverse Train",
                select_reverse_train: "Select Reverse Train",
                do_you_really_want_to_delete_this_station: "Do you really want to delete this station?",
                edit_train_station: "Edit Train Station",
                zone_1: "Zone 1",
                zone_2: "Zone 2",
                zone_3: "Zone 3",
                zone_4: "Zone 4",
                distance_from_maputo: "Distance from Maputo (KM)",
                add_automotora_price: "Add Automotora Price",
                fare_charge: "Fare Charge",
                long_train_prices: "Long Train Prices",
                add_normal_price: "Add Normal Price",
                origin: "Origin",
                price_off_train: "Price Off Train",
                price_on_train: "Price On Train",
                class_type: "Class Type",
                edit_zone_price: "Edit Zone Price",
                edit_automotora_price: "Edit Automotora Price",
                fair_charges: "Fair Charges",
                updated_date: "Updated Date",
                station_train_schedules: "Station Train Schedules",
                add_station_train_schedule: "Add Station Train Schedule",
                edit_station_train_schedule: "Edit Station Train Schedule",
                week_day: "Week Days",
                edit_train_schedule: "Edit Train Schedule",
                add_train_schedule: "Add Train Schedule",
                train_station: "Train Station",
                you_can_only_add_up_to_4_zones: "You Can Only Add Up to 4 Zones!",
                add_new_zone: "Add New Zonal",
                edit_zonal_price: "Edit Zonal Price",
                zone_list: "Zone List",
                zonal_name: "Zonal Name",
                select_zone: "Select Zone",
                add_role: "Add Role",
                edit_role: "Edit Role",
                role_name: "Role Name",
                roles: "Roles",
                role: "Role",
                system_users: "System Users",
                all_users: "All Users",
                add_user: "Add User",
                edit_user: "Edit User",
                contact_info: "Contact Info",
                add_new_user: "Add New User",
                mobile_number: "Mobile Number",
                operator_types: "Operator Types",
                operator_categories: "Operator Categories",
                edit_new_user: "Edit New User",
                do_you_really_want_to_reset_password: "Do you really want to reset password?",
                user_details: "User Details",
                deactivate: "Deactivate",
                activate: "Activate",
                do_you_really_want_to_deactivate_user: "Do you really want to deactivate user?",
                do_you_really_want_to_activate_user: "Do you really want to activate user?",
                assign_action_for: "Asign Action For ",
                crude_operation: "CRUDE Operation",
                train_schedules: "Train Schedules",
                all_train_schedules: "All Train Schedules",
                select_trip_duration_hours: "Select Trip Duration Hours",
                select_train: "Select Train",
                edit_schedule_details: "Edit Schedule Details",
                select_day: "Select Days",
                all_days: "All Days",
                destination_time: "Destination Time",
                add_manufacture: "Add Manufacture",
                invalid_message_manufacture: "Invalid manufacture, contact admin for support",
                coach_manufactures: "Coach Manufactures",
                all_coach_manufactures: "All Coach Manufacture",
                coach_layouts: "Coach Layouts",
                all_coach_layouts: "All Couch Layouts",
                add_coach_layout: "Add Couch Layout",
                seat_type: "Seat Type",
                standing_seats: "Standing Seats",
                layout_name: "Layout Name",
                layout_label: "Layout Label",
                coach_manufacture: "Coach Manufacture",
                select_coach_manufacture: "Select Coach Manufacture",
                select_seat_type: "Select Seat Type",
                number_of_seats: "Number of Seats",
                number_of_standing_slots: "Number of Standing Slots",
                number_of_seats_rows: "Number of seats row",
                number_of_seats_columns: "Number of Seats Colums",
                number_of_seats_aisle: "Number of Seats Aisle",

                coach_layout_details: "Coach Layouts Details",
                coach_category: "Coach Category",
                coach_label: "Coach Label",
                aisle_column: "Aisle Column",
                coaches_list: "Coaches List",
                seat_number: "Seat Number",
                aisle_seat: "Aisle Seat",
                train_coaches: "Train Coaches",
                all_train_coaches: "All Train Coaches",
                add_train_coach: "Add Train Coach",
                select_coach_type: "Select Coach Type",
                edit_coach: "Edit Coach",
                do_you_really_want_to_delete_this_wagon: "Do you really want to delete this wagon?",
                add_news: "Add News",
                all_news_updates: "All News Updates",
                news_updates: "News & Updates",
                show_details_news: "Show Details News",
                POS_kiosk: "POS_kiosk",
                do_you_really_want_to_complete_this: "Do you really want to complete this ?",

                information_updates: "Information Updates",
                all_information_updates: "All Information Updates",
                add_information: "Add Information",
                do_you_really_want_to_delete_this: "Do you Really Want to Delete this ?",

                show_details_information: "Show Details Information",
                unpublish_information: "Unpublish Information",
                publish_information: "Publish Information",
                this_action_can_no_be_undone: "This action can no be undone",
                audit_trail: "Audit Trail",
                audit_trails: "Audit Trails",
                parameter: "Parameter",
                old_data: "Old Data",
                new_data: "New Data",
                changed: "Changed",
                unchanged: "Unchanged",
                audit_details: "Audit Details",
                amount_collected: "Amount Collected",
                special_group_discount: "Special Group Discount",
                add_special_group: "Add Special Group",
                group_title: "Group Title",
                discount_percentages: "Zona Discount (%)",
                main_category: "Main Category",
                for_transaction: "For Transaction",
                special_group_title: "Special Group Title",
                yes: "Yes",
                edit_special_group: "Edit Special Group",
                operator_incentives_configurations: "Operator Incentives Configurations",
                add_incentive_configuration: "Add Incentive Configuration",
                edit_details: "Edit Details",
                app_type: "App Type",
                upload_new_apk: "Upload New Apk",
                download: "Download",
                choose_upload_type: "Choose Upload Type",
                apk_file: "APK File",
                train_layout: "Train Layout",
                compatment: "Compatment",
                number_of_seat: "Number of Seat",
                number_of_cabin: "Number of Cabin",
                number_of_compatment: "Number of Compatment",
                edit_train_layout: "Edit Train Layout",
                cancel_selected: "Cancel Selected",
                select_all: "Select All",
                collections_deposit: "Collections Deposit",
                amount_submitted: "Amount Submitted",
                pre_post_process: "Pre Post Process",
                select_operator: "Select Operator",
                select_transaction_type: "Select Transaction Type",
                train_direction: "Train Direction",
                select_train_direction: "Select Train Direction",
                departure_date_time: "Departure Date & Time",
                arrival_date_time: "Arrival Date & Time",
                operator_accounts: "Operator Accounts",
                all_operator_accounts: "All Operator Accounts",
                system_amount: "System Amount",
                total_coaches: "Total Coaches",
                all_train_layouts: "All Train Layouts",
                train_layouts: "Train Layouts",
                add_train_layout: "Add Train Layout",
                add_wagon: "Add Wagon",
                delete_records_confirm: "Do you really want to delete these records?",
                process_cannot_be_undone: "This process cannot be undone.",
                do_you_really_want_to_delete_this_train_layout: "Do you really want to delete this train layout?",

                edit_long_train_price: "Edit Long Train Price",
                choose_class: "Choose Class",
                no_results: "No Results",
                try_adjusting: "Try Adjusting",
                update_fare_charges_for_different_groups: "Update fare charges for different groups",

                normal_prices: "Normal Prices",
                off_train_fare: "Off Train Fare",
                on_train_fare: "On Train Fare",
                group_one_prices_adult: "Group One Prices (Other Special Groups)",
                off_train_fare_group_1: "Off Train Fare - Group 1",
                on_train_fare_group_1: "On Train Fare - Group 1",
                group_two_prices_other_special_groups: "Group Two Prices (Adult)",
                off_train_fare_group_2: "Off Train Fare - Group 2",
                on_train_fare_group_2: "On Train Fare - Group 2",
                update_price: "Update Price",
                updating: "Updating...",

                on_train_fare_charge: "On Train Fare Charge",
                off_train_fare_charge: "Off Train Fare Charge",
                enter_charge: "Enter charge",

                add_new_train_price: "Add New Train Price",
                choose_train_line: "Choose Train Line",
                from_train_station: "From Train station",
                choose_from_train_station: "Choose From Train station",
                to_train_station: "To Train station",
                choose_to_train_station: "Choose To Train station",
                fare_price: "Fare Price",
                distance: "Distance",
                reverse_train_route: "Reverse Train",
                carde_type: "Card Type",
                card_details_description: "Update card information and settings",
                last_top_up_date: "Last Top Up Date",

                account_information: "Account Information",
                primary_account_details: "Main Account Details and Information",
                personal_info: "Personal Information",
                account_details_section: "Account Details",
                linked_card: "Linked Card",
                other_accounts: "Other Accounts",
                associated_accounts_description: "Associated accounts and cards linked to this customer",
                accounts_count: "Account(s)",
                no_other_accounts: "No Other Accounts",
                no_other_accounts_description: "This customer does not yet have any related or linked accounts.",
                update_customer_account_info: "Update customer account information",
                no_card: "No Card",
                no_card_assigned: "No Card Assigned",
                view: "View",
                field_is_read_only: "This field is read-only",
                normal_card: "Regular Card",
                select_package_type: "Select Package Type",
                select_report_module: "Select Report Module",
                showing_to_of: "Showing to of",
                off_train_price: "Off Train Price",
                on_train_price: "On Train Price",
                filters: "Filters",
                search_placeholder: "Search...",
                all_stations: "All Stations",
                all_classes: "All Classes",
                all_lines: "All Lines",
                province: "Province",
                ascending_zone: "Ascending Zone",
                descending_zone: "Descending Zone",
                no_zone: "No Zone",
                cardNumber: "Card Number",
                uknown: "Uknown",
                none: "None",
                fiscal_officer: "Fiscal Officer",
                card_number_cannot_be_changed: "Card number cannot be changed",
                save_changes: "Save Changes",
                current_card_details: "Current Card Details",
                update_card_information: "Update Card Information",
                client: "Customer",
                employee: "Employee",
                automotora_package: "Automotora Package",
                cfm_cash_payment: "CFM Cash Payment Transactions",
                second_class_normal: "2nd Class Normal All Line",
                ministry_transportation: "Ministry of Transportation",
                bus_package: "Bus Package",
                choose_base_station: "Choose Base Station",
                no_station: "No Station",
                choose_device_type: "Choose Device Type",
                enter_device_imei: "Enter Device IMEI",
                enter_device: "Enter Device ",
                nothing: "Nothing",
                all_tickets: "All Tickets",
                choose_on_off_train: "Choose ON-OFF train",
                choose_allowed_sales: "Choose Allowed Sales",
                add_edit_device: "Add Edit Device",
                enter_device_serial: "Enter device serial",
                enter_app_version: "Enter app version",
                enter_printer_bda: "Enter Printer BDA",
                enter_balance_vendor_id: "Enter balance vendor id",
                enter_balance_product_id: "Enter balance product id",

                device_version: "Device version",
                enter_device_version: "Enter device version",
                log_off_sec: "Log Off(sec)",
                choose_status: "Choose status",


                // penalt page
                train_penalty: "Train Penalty",
                train_penalties: "Train Penalties",
                penalty_management: "Penalty Management",
                penalty_configuration: "Penalty Configuration",
                penalty_values: "Penalty Values",
                first_class_penalty: "First Class Penalty",
                second_class_penalty: "Second Class Penalty",
                third_class_penalty: "Third Class Penalty",
                edit_penalty: "Edit Penalty",
                edit_penalty_values: "Edit Penalty Values",
                update_penalty: "Update Penalty",
                penalty_amount: "Penalty Amount",
                avg_first_class: "Avg First Class",
                avg_second_class: "Avg Second Class",
                avg_third_class: "Avg Third Class",
                total_routes: "Total Routes",
                enter_penalty_value: "Enter penalty value",
                penalty_updated_successfully: "Penalty values updated successfully",
                no_routes_found: "No routes found",
                loading_penalty_data: "Loading penalty data...",
                manage_penalty_values: "Manage penalty values for different train classes and routes",
                refresh_data: "Refresh Data",
                export_report: "Export Report",
                saving: "Saving...",
                clear_all: "Clear All",
                all_directions: "All Directions",
                search_auto_update: "Search auto update",
                add_zone:"Add Zone",
                zonal_code:"Zonal Code",
                select_train_type:"Select Train Type",
                delete_zone_price_confirmation: "Do you really want to delete this zone price?",
                this_action_cannot_be_undone: "This action cannot be undone.",
                select_group: "Select Group",
                delete_automotora_price_confirmation: "Do you really want to delete this automotora price?",
                delete_normal_price_confirmation: "Do you really want to delete this normal price?",
                select_lines:"Select Lines",
                edit_train_route: "Edit Train Route",
                update:"Update",
                stations_cannot_be_edited:"Station editing is not allowed",
                zone_configuration:"Zone Configuration",
                class_configuration:"Class Configuration",
                basic_information: "Basic Information",
                route_information: "Route Information",
                journey_details: "Journey Details",
                service_options:"Service Options",
                train_classes:"Train Classes",
                station_information:"Station Information",
                do_you_really_want_to_delete_this_route:"Do you really want to delete this route?",
            //
                manage_passenger_discount_categories: "Manage passenger discount categories and fare percentages",
                special_group_list: "Special Groups",
                records: "records",
                normal_train_percent: "Normal Train %",
                default: "Default",
                no_data: "No data found",
                required_fields: "Required fields",
                group_information: "Group Information",
                identity: "Identity",
                discount_settings: "Discount Settings",
                categorization: "Categorization",
                preview: "Preview",
                add_special_group_subtitle: "Create a new passenger discount category",
                total_groups: "Total Groups",
                used_for_transactions: "Used for Transactions",
                with_discount: "With Discount",
                default_groups: "Default Groups",
                search_by_title_or_code: "Search by title or code...",
                all_categories: "All Categories",
                filter_by_category: "Filter by category",
                search_categories: "Search categories...",
                confirm_delete: "Confirm Delete",
                delete_warning: "This action cannot be undone.",
                discount_applied_standard_fare: "Discount applied on standard fare",
                applies_normal_train: "Applies on normal train services",
                zero_means_unlimited: "0 means unlimited",
                optional_short_code: "Optional short code",
                number_of_trips: "Number of Trips",

                // ── App Version Management additions ──────────────────────
                settings: "Settings",
                app_version_management: "App Version Management",
                manage_apk_releases: "Manage APK releases for POS and Kiosk devices",
                total_versions: "Total Versions",
                across_all_types: "across all types",
                currently_deployed: "currently deployed",
                forced_updates: "forced updates",
                latest: "Latest",
                most_recent_build: "most recent build",
                version_history: "Version History",
                all_types: "All types",
                created: "Created",
                no_versions_match: "No versions match your filters",
                no_download_url: "No download URL available for this version",
                back_to_versions: "Back to versions",
                upload_page_subtitle: "Select an APK file — version detected from filename, description auto-generated, edit anything as needed",
                clear: "Clear",
                drop_apk_here: "Drop APK here or click to browse",
                only_apk_accepted: "Only .apk files accepted",
                filename_should_contain: "Filename should contain version (e.g. v2.4.8 or v248)",
                please_select_apk: "Please select an APK file",
                could_not_detect_version: "Could not detect version from filename",
                version_detected: "Version detected:",
                could_not_detect_version_long: "Could not detect version — filename must contain v2.4.8 or v248",
                version_details: "Version Details",
                auto_detected_from_filename: "Auto-detected from filename",
                app_type_all_devices: "ALL — All devices",
                app_type_pos: "POS — Point of Sale",
                app_type_kiosk: "KIOSK — Kiosk devices",
                mandatory_update: "Mandatory Update",
                optional_update: "No — optional update",
                forced_update: "Yes — forced update",
                version_end_date: "Version End Date",
                version_end_date_required: "Version end date is required",
                description_required: "Description is required",
                description_placeholder: "e.g. Bug fixes and performance improvements for v2.4.8",
                regenerate: "Regenerate",
                auto_generated_edit_anytime: "Auto-generated — edit anytime",
                custom_description: "Custom description",
                uploading: "Uploading...",
                upload_and_save: "Upload & Save",
                version_uploaded_success: "Version v{version} uploaded successfully.",
                unexpected_error: "Unexpected error",
                desc_template_all: "General release v{version} for all devices — bug fixes and enhancements",
                desc_template_pos: "POS release v{version} — bug fixes and performance improvements",
                desc_template_kiosk: "Kiosk release v{version} — UI improvements and bug fixes",
                forced_update_suffix: "mandatory update",
                discounted_price: "Discounted Price",
                discounted_price_hint: "Leave blank or 0 if no discount applies",

                // PHC Sync page
                push: "push",
                master: "master",
                processing: "processing",
                successful: "successful",
                welcome_to_xitimela_portal: "Welcome to Xitimela Portal",
                manage_new_registrations: "Manage new passenger registrations and card allocations",
                total_registrations: "Total Registrations",
                cards_allocated: "Cards Allocated",
                pending_allocations: "Pending Allocations",
                new_registrations_pending_card: "New Registrations Pending Card Allocation",
                review_documents_and_allocate: "Review documents and allocate cards",
                loading: "Loading",
                documents: "Documents",
                allocate_card: "Allocate Card",
                no_pending_registrations: "No pending registrations",
                passenger_documents: "Passenger Documents",
                no_id_uploaded: "No ID uploaded",
                no_passport_uploaded: "No passport uploaded",
                close: "Close",
            }
        },
        pt:
        {
            message: {
                welcome_to_xitimela_portal: "Bem-vindo ao Portal Xitimela",
                manage_new_registrations: "Gerir novos registos de passageiros e atribuição de cartões",
                total_registrations: "Total de Registos",
                cards_allocated: "Cartões Atribuídos",
                pending_allocations: "Atribuições Pendentes",
                new_registrations_pending_card: "Novos Registos a Aguardar Atribuição de Cartão",
                review_documents_and_allocate: "Rever documentos e atribuir cartões",
                loading: "A carregar",
                documents: "Documentos",
                allocate_card: "Atribuir Cartão",
                no_pending_registrations: "Nenhum registo pendente",
                passenger_documents: "Documentos do Passageiro",
                no_id_uploaded: "Nenhuma identificação carregada",
                no_passport_uploaded: "Nenhum passaporte carregado",
                close: "Fechar",
                // PHC Sync
                push: "enviar",
                master: "principal",
                data: "dados",
                processing: "a processar",
                successful: "com sucesso",

                discounted_price: "Preço com Desconto",
                discounted_price_hint: "Deixe em branco ou 0 se não houver desconto",
                // ── Gestão de Versões da Aplicação ────────────────────────
                mandatory: "Obrigatório",
                settings: "Configurações",
                app_version_management: "Gestão de Versões da Aplicação",
                manage_apk_releases: "Gerir lançamentos APK para dispositivos POS e Kiosk",
                total_versions: "Total de Versões",
                across_all_types: "em todos os tipos",
                currently_deployed: "actualmente implementado",
                forced_updates: "actualizações forçadas",
                latest: "Mais Recente",
                most_recent_build: "compilação mais recente",
                version_history: "Histórico de Versões",
                all_types: "Todos os tipos",
                created: "Criado",
                no_versions_match: "Nenhuma versão corresponde aos filtros",
                no_download_url: "Sem URL de descarga para esta versão",
                back_to_versions: "Voltar às versões",
                upload_page_subtitle: "Seleccione um ficheiro APK — versão detectada do nome, descrição gerada automaticamente, edite conforme necessário",
                clear: "Limpar",
                drop_apk_here: "Arraste o APK aqui ou clique para procurar",
                only_apk_accepted: "Apenas ficheiros .apk são aceites",
                filename_should_contain: "O nome do ficheiro deve conter a versão (ex. v2.4.8 ou v248)",
                please_select_apk: "Por favor seleccione um ficheiro APK",
                could_not_detect_version: "Não foi possível detectar a versão do nome do ficheiro",
                version_detected: "Versão detectada:",
                could_not_detect_version_long: "Não foi possível detectar a versão — o nome do ficheiro deve conter v2.4.8 ou v248",
                version_details: "Detalhes da Versão",
                auto_detected_from_filename: "Detectado automaticamente do nome do ficheiro",
                app_type_all_devices: "ALL — Todos os dispositivos",
                app_type_pos: "POS — Ponto de Venda",
                app_type_kiosk: "KIOSK — Dispositivos Kiosk",
                mandatory_update: "Actualização Obrigatória",
                optional_update: "Não — actualização opcional",
                forced_update: "Sim — actualização forçada",
                version_end_date: "Data Final da Versão",
                version_end_date_required: "Data final da versão é obrigatória",
                description_required: "Descrição é obrigatória",
                description_placeholder: "ex. Correcções e melhorias de desempenho para v2.4.8",
                regenerate: "Regenerar",
                auto_generated_edit_anytime: "Gerado automaticamente — edite a qualquer momento",
                custom_description: "Descrição personalizada",
                uploading: "A carregar...",
                upload_and_save: "Carregar e Guardar",
                version_uploaded_success: "Versão v{version} carregada com sucesso.",
                unexpected_error: "Erro inesperado",
                desc_template_all: "Lançamento geral v{version} para todos os dispositivos — correcções e melhorias",
                desc_template_pos: "Lançamento POS v{version} — correcções e melhorias de desempenho",
                desc_template_kiosk: "Lançamento Kiosk v{version} — melhorias de UI e correcções",
                forced_update_suffix: "actualização obrigatória",
                // Special Group page additions
                manage_passenger_discount_categories: "Gerir categorias de desconto de passageiros e percentagens de tarifa",
                special_group_list: "Grupos Especiais",
                records: "registos",
                normal_train_percent: "% Comboio Normal",
                default: "Padrão",
                no_data: "Nenhum dado encontrado",
                required_fields: "Campos obrigatórios",
                group_information: "Informações do Grupo",
                identity: "Identidade",
                discount_settings: "Definições de Desconto",
                categorization: "Categorização",
                preview: "Pré-visualização",
                add_special_group_subtitle: "Criar uma nova categoria de desconto de passageiro",
                total_groups: "Total de Grupos",
                used_for_transactions: "Usado em Transações",
                with_discount: "Com Desconto",
                default_groups: "Grupos Padrão",
                search_by_title_or_code: "Pesquisar por título ou código...",
                all_categories: "Todas as Categorias",
                filter_by_category: "Filtrar por categoria",
                search_categories: "Pesquisar categorias...",
                confirm_delete: "Confirmar Eliminação",
                delete_warning: "Esta ação não pode ser desfeita.",
                discount_applied_standard_fare: "Desconto aplicado sobre a tarifa padrão",
                applies_normal_train: "Aplica-se em comboios normais",
                zero_means_unlimited: "0 significa ilimitado",
                optional_short_code: "Código curto opcional",
                number_of_trips: "Número de Viagens",
                //
                do_you_really_want_to_delete_this_route:"Tem mesmo vontade de apagar esta rota? ",
                station_information:"Informações da estação",
                service_options:"Opções de serviço",
                train_classes:"Aulas de comboio",
                basic_information: "Informações Básicas",
                route_information: "Informações da Rota",
                journey_details: "Detalhes da Viagem",
                zone_configuration:"Configuração de zona",
                class_configuration:"Configuração de classe",
                stations_cannot_be_edited:"Edição de estações não permitida",
                update:"Pesquisar",
                edit_train_route:"Editar Rota do Trem",
                select_lines: "Selecione as linhas",
                delete_automotora_price_confirmation: "Você realmente deseja excluir este preço de automotora?",
                delete_normal_price_confirmation: "Você realmente deseja excluir este preço normal?",
                delete_zone_price_confirmation: "Você realmente deseja excluir este preço de zona?",
                this_action_cannot_be_undone: "Esta ação não pode ser desfeita.",
                select_train_type:"Selecione o tipo de trem",
                search_auto_update: "Pesquisar atualização automática",
                add_zone:"Adicionar Zona",
                zonal_code:"zona code",
                train_penalty: "Penalização de Comboio",
                train_penalties: "Penalizações de Comboio",
                penalty_management: "Gestão de Penalizações",
                penalty_configuration: "Configuração de Penalizações",
                penalty_values: "Valores de Penalização",
                first_class_penalty: "Penalização de Primeira Classe",
                second_class_penalty: "Penalização de Segunda Classe",
                third_class_penalty: "Penalização de Terceira Classe",
                edit_penalty: "Editar Penalização",
                edit_penalty_values: "Editar Valores de Penalização",
                update_penalty: "Atualizar Penalização",
                penalty_amount: "Valor da Penalização",
                avg_first_class: "Média Primeira Classe",
                avg_second_class: "Média Segunda Classe",
                avg_third_class: "Média Terceira Classe",
                total_routes: "Total de Rotas",
                enter_penalty_value: "Inserir valor da penalização",
                penalty_updated_successfully: "Valores de penalização atualizados com sucesso",
                no_routes_found: "Nenhuma rota encontrada",
                loading_penalty_data: "Carregando dados de penalização...",
                manage_penalty_values: "Gerir valores de penalização para diferentes classes de comboio e rotas",
                refresh_data: "Atualizar Dados",
                export_report: "Exportar Relatório",
                saving: "Guardando...",
                clear_all: "Limpar Tudo",
                all_directions: "Todas as Direções",

                choose_status: "Escolha o status",
                device_version: "Versão do dispositivo",
                enter_device_version: "Introduza a versão do dispositivo",
                log_off_sec: "Desconectar(seg)",
                enter_balance_vendor_id: "Introduza o ID do fornecedor de saldo",
                enter_balance_product_id: "Introduza o ID do produto de saldo",
                enter_device_serial: "Introduza a série do dispositivo",
                enter_printer_bda: "Introduza a Impressora BDA",
                enter_app_version: "Introduza a versão da aplicação",
                add_edit_device: "Adicionar Editar Dispositivo",
                choose_allowed_sales: "Escolha vendas permitidas",
                choose_on_off_train: "Escolha o trem ON-OFF",
                all_tickets: "Todos os Bilhetes",
                nothing: "Nenhum",
                enter_device: "Introduza o Dispositivo",
                enter_device_imei: "Introduza o IMEI do Dispositivo",
                choose_device_type: "Escolha o Tipo de Dispositivo",
                no_station: "Sem estação",
                choose_base_station: "Escolha a estação base",
                bus_package: "Pacote de Ônibus",
                automotora_package: "Pacote Automotora",
                cfm_cash_payment: "Transações de Pagamento em Dinheiro CFM",
                second_class_normal: "2ª Classe Normal Todas as Linhas",
                ministry_transportation: "Ministério dos Transportes",
                client: "Cliente",
                employee: "Funcionário",
                update_card_information: "Atualizar Informações do Cartão",
                current_card_details: "Detalhes Atuais do Cartão",
                save_changes: "Salvar Alterações",
                card_number_cannot_be_changed: "O número do cartão não pode ser alterado",
                fiscal_officer: "Fiscal",
                none: "Nenhum",
                uknown: "Desconhecida",
                company: "empresa",
                cardNumber: "Número do Cartão",
                no_zone: "Nenhum",
                ascending_zone: "Zona Ascendente",
                descending_zone: "Zona Descendente",
                province: "Província",
                all_lines: "Todas as Linhas",
                all_classes: "Todas as Classes",
                all_stations: "Todas as Estações",
                search_placeholder: "Pesquisar...",
                filters: "Filtros",
                off_train_price: "Preço Fora do Trem",
                on_train_price: "Preço no Trem",
                showing_to_of: "Mostrando para de",
                select_report_module: "Selecionar Módulo de Relatório",
                select_package_type: "Selecionar Tipo de Pacote",
                field_is_read_only: "Este campo é somente leitura",
                update_customer_account_info: "Atualizar informações da conta do cliente",
                account_information: "Informações da Conta",
                primary_account_details: "Detalhes e informações da conta principal",
                personal_info: "Informações Pessoais",
                account_details_section: "Detalhes da Conta",
                linked_card: "Cartão Vinculado",
                other_accounts: "Outras Contas",
                associated_accounts_description: "Contas e cartões associados vinculados a este cliente",
                accounts_count: "Conta(s)",
                no_other_accounts: "Sem Outras Contas",
                no_other_accounts_description: "Este cliente ainda não possui outras contas relacionadas ou vinculadas.",

                no_card: "Sem Cartão",
                no_card_assigned: "Nenhum Cartão Atribuído",
                view: "Ver",

                card_type: "Tipo de Cartão",
                normal_card: "Cartão Normal",
                add_new_train_price: "Adicionar Novo Preço de Trem",
                choose_train_line: "Escolher Linha de Trem",
                from_train_station: "Da Estação de Trem",
                choose_from_train_station: "Escolher Da Estação de Trem",
                to_train_station: "Para Estação de Trem",
                choose_to_train_station: "Escolher Para Estação de Trem",

                carde_type: "Tipo de Cartão",

                //

                last_top_up_date: "Data do Último Recarregamento",
                card_details_description: "Atualizar informações e configurações do cartão",

                train_class: "Classe de Trem",
                choose_train_class: "Escolher Classe de Trem",
                fare_price: "Preço da Tarifa",
                distance: "Distância",
                reverse_train_route: "Trem reverso",
                edit_long_train_price: "Editar Preço de Trem de Longa Distância",
                no_results: "Nenhum Resultado",
                try_adjusting: "Tente ajustar",
                choose_class: "Escolha as aulas",
                update_fare_charges_for_different_groups: "Atualizar tarifas para diferentes grupos",
                on_train_fare_charge: "Tarifa no Trem",
                off_train_fare_charge: "Tarifa Fora do Trem",
                enter_charge: "Inserir tarifa",
                normal_prices: "Preços Normais",
                off_train_fare: "Tarifa Fora do Trem",
                on_train_fare: "Tarifa no Trem",
                group_one_prices_adult: "Preços Grupo Um (Outros Grupos Especiais)",
                off_train_fare_group_1: "Tarifa Fora do Trem - Grupo 1",
                on_train_fare_group_1: "Tarifa no Trem - Grupo 1",
                group_two_prices_other_special_groups: "Preços Grupo Dois (Idoso)",
                off_train_fare_group_2: "Tarifa Fora do Trem - Grupo 2",
                on_train_fare_group_2: "Tarifa no Trem - Grupo 2",
                update_price: "Atualizar Preço",
                updating: "Atualizando...",
                delete_records_confirm: "Você realmente quer deletar estes registros?",
                process_cannot_be_undone: "Este processo não pode ser desfeito.",

                do_you_really_want_to_delete_this_train_layout: "Você realmente quer deletar este layout de trem?",

                add_wagon: "Adicionar Vagão",
                train_layouts: "Layouts de Trem",
                all_train_layouts: "Todos os Layouts de Trem",
                total_coaches: "Total de Vagões",
                operator_accounts: "Contas de Operadores",
                all_operator_accounts: "Todas as Contas de Operadores",
                system_amount: "Quantia do Sistema",
                pre_post_process: "Pré/Pós Processamento",
                select_operator: "Selecione o Operador",
                select_transaction_type: "Selecione o Tipo de Transação",
                train_direction: "Direção do Trem",
                select_train_direction: "Selecione a Direção do Trem",
                departure_date_time: "Data e Hora de Partida",
                arrival_date_time: "Data e Hora de Chegada",
                amount_submitted: "Quantia Submetida",
                collections_deposit: "Depósito de Coletas",
                select_all: "Selecionar Todos",
                cancel_selected: "Cancelar Selecionados",
                choose_upload_type: "Escolher Tipo de Upload",
                apk_file: "Arquivo APK",
                download: "Baixar",
                app_type: "Tipo de Aplicativo",
                upload_new_apk: "Carregar Novo Apk",
                add_incentive_configuration: "Adicionar Configuração de Incentivo",
                edit_details: "Editar Detalhes",
                operator_incentives_configurations: "Configurações de Incentivos do Operador",
                special_group_title: "Título do Grupo Especial",
                discount_percentage: "Percentual de Desconto",
                yes: "Sim",
                edit_special_group: "Editar Grupo Especial",
                special_group_discount: "Desconto de Grupo Especial",
                add_special_group: "Adicionar Grupo Especial",
                group_title: "Título do Grupo",
                discount_percentages: "Zona de Desconto (%)",
                main_category: "Categoria Principal",
                for_transaction: "Para Transação",
                amount_collected: "Quantia Coletada",
                audit_details: "Detalhes da auditoria",
                changed: "Alterado",
                unchanged: "Inalterado",
                parameter: "Parâmetro",
                old_data: "Dados antigos",
                new_data: "Novos dados",
                this_action_can_no_be_undone: "Esta ação não pode ser desfeita",
                audit_trails: "Trilhas de auditoria",
                audit_trail: "Trilha de auditoria",
                show_details_information: "Mostrar detalhes da informação",
                unpublish_information: "Despublicar informação",
                publish_information: "Publicar informação",
                information_updates: "Atualizações de informação",
                all_information_updates: "Todas as atualizações de informação",
                add_information: "Adicionar informação",
                do_you_really_want_to_delete_this: "Você realmente quer deletar isto?",
                show_details_news: "Mostrar detalhes da notícia",
                POS_kiosk: "POS_quiosque",
                do_you_really_want_to_complete_this: "Você realmente quer completar isto?",
                add_news: "Adicionar notícia",
                all_news_updates: "Todas as atualizações de notícias",
                news_updates: "Notícias e atualizações",
                aisle_seat: "Assento do Corredor",
                train_coaches: "Vagões do Trem",
                all_train_coaches: "Todos os Vagões do Trem",
                add_train_coach: "Adicionar Vagão do Trem",
                select_coach_type: "Selecionar Tipo de Vagão",
                edit_coach: "Editar Vagão",
                do_you_really_want_to_delete_this_wagon: "Você realmente deseja excluir este vagão?",
                coach_layout_details: "Detalhes dos Layouts dos Ônibus",
                coach_category: "Categoria do Ônibus",
                coach_label: "Rótulo do Ônibus",
                aisle_column: "Coluna do Corredor",
                coaches_list: "Lista de Ônibus",
                seat_number: "Número do Assento",
                number_of_seats_aisle: "Número de assentos no corredor",
                number_of_seats_columns: "Número de assentos Colunas",
                number_of_seats_rows: "Número de filas de assentos",
                number_of_standing_slots: "Número de vagas em pé",
                number_of_seats: "Número de assentos",
                select_coach_manufacture: "Selecione Fabricação de ônibus",
                standing_seats: "Assentos em pé",
                seat_type: "Tipo de assento",
                select_seat_type: "Selecione o tipo de assento",
                add_coach_layout: "Adicionar layout de sofá",
                all_coach_layouts: "Todos os layouts de sofá",
                coach_layouts: "Layouts de treinador",
                coach_manufactures: "Fabricantes de ônibus",
                coach_manufacture: "Fabricante de ônibus",
                all_coach_manufactures: "Toda a fabricação de ônibus",
                invalid_message_manufacture: "Fabricação inválida, entre em contato com o administrador para obter suporte",
                add_manufacture: "Adicionar Fabricação",
                destination_time: "Hora de destino",
                all_days: "Todos os dias",
                select_day: "Selecione os dias",
                edit_schedule_details: "Editar detalhes da programação",
                select_train: "Selecione Trem",
                select_trip_duration_hours: "Selecione a duração da viagem em horas",
                all_train_schedules: "Todos os horários dos trens",
                train_schedules: "Horários de trem",
                crude_operation: "Operação CRUD",
                assign_action_for: "Atribuir ação para",
                deactivate: "Desativar",
                activate: "Ativar",
                do_you_really_want_to_deactivate_user: "Você realmente quer desativar o usuário?",
                do_you_really_want_to_activate_user: "Você realmente quer ativar o usuário?",
                user_details: "Detalhes do usuário",
                do_you_really_want_to_reset_password: "Você realmente deseja redefinir a senha?",
                edit_new_user: "Editar Novo Usuário",
                operator_categories: "Categorias de Operadores",
                operator_types: "Tipos de Operadores",
                mobile_number: "Número de Telefone",
                add_new_user: "Adicionar Novo Usuário",
                contact_info: "Informações de Contato",
                all_users: "Todos os Usuários",
                add_user: "Adicionar Usuário",
                edit_user: "Editar Usuário",
                system_users: "Usuários do Sistema",
                roles: "Funções",
                role: "Função",
                add_role: "Adicionar Função",
                edit_role: "Editar Função",
                role_name: "Nome da Função",
                select_zone: "Selecionar Zona",
                zonal_name: "Nome da Zona",
                edit_zonal_price: "Editar Preço Zonal",
                zone_list: "Lista de zonas",
                add_new_zone: "Adicionar Nova Zona",
                you_can_only_add_up_to_4_zones: "Você só pode adicionar até 4 zonas!",
                train_station: "Estação de Trem",
                add_train_schedule: "Adicionar Horário do Trem",
                edit_train_schedule: "Editar Horário do Trem",
                week_day: "Dias da Semana",
                add_station_train_schedule: "Adicionar Horário da Estação de Trem",
                edit_station_train_schedule: "Editar Horário da Estação de Trem",
                station_train_schedules: "Horários das Estações de Trem",
                updated_date: "Data de Atualização",
                edit_automotora_price: "Editar Preço da Automotora",
                fair_charges: "Custo das Tarifas",
                edit_zone_price: "Editar Preço da Zona",
                price_off_train: "Preço Fora do Trem",
                price_on_train: "Preço No Trem",
                class_type: "Tipo de Classe",
                origin: "Origem",
                add_normal_price: "Adicionar Preço Normal",
                long_train_prices: "Preços de Trem Longo",
                fare_charge: "Custo da Tarifa",
                add_automotora_price: "Adicionar Preço de Automotora",
                zone_1: "Zona 1",
                zone_2: "Zona 2",
                zone_3: "Zona 3",
                zone_4: "Zona 4",
                distance_from_maputo: "Distância de Maputo (KM)",
                edit_train_station: "Editar Estação de Trem",
                origin_station: "Estação de Origem",
                do_you_really_want_to_delete_this_station: "Você realmente quer deletar esta estação?",
                select_reverse_train: "Selecionar Trem Reverso",
                reverse_train: "Trem Reverso",
                automotra: "Automotora",
                edit_train_details: "Editar Detalhes do Trem",
                operational: "Operacional",
                route_direction: "Direção da Rota",
                support_zone_one: "Suporte Zona Um",
                support_zone_two: "Suporte Zona Dois",
                support_zone_three: "Suporte Zona Três",
                support_zone_four: "Suporte Zona Quatro",
                support_first_class: "Suporte Primeira Classe",
                support_second_class: "Suporte Segunda Classe",
                support_third_class: "Suporte Terceira Classe",
                arrival_day: "Dias de Chegada",
                departure_day: "Dias de Partida",
                departure_time: "Hora de Partida",
                arrival_time: "Hora de Chegada",
                reverse_train_number: "Número do Trem Reverso",
                first_group: "Primeiro Grupo",
                second_group: "Segundo Grupo",
                third_group: "Terceiro Grupo",
                zonal: "Zonal",
                automotora: "Automotora",
                continue: "Continuar",
                do_you_really_want_to_delete_this_train: "Você realmente quer deletar este trem?",
                add_train_line: "Adicionar Nova Linha de Trem",
                train_line_name: "Nome da Linha de Trem",
                distance_km: "Distância (KM)",
                edit_train_line: "Editar Linha de Trem",
                add_line: "Adicionar Linha",
                edit_line: "Editar Linha",
                line_details: "Detalhes da Linha",
                add_edit_train_class: "Adicionar/Editar Classe de Trem",
                add_class: "Adicionar Classe",
                do_not_accept_more_than_lines: "Não aceite mais de 3 linhas!",
                tatal_amount: "Montante Total",
                tatal_transactions: "Total de Transações",
                recently_operator_transactions: "Transações Recentes do Operador",
                recently_train_transactions: "Transações Recentes do Trem",
                check_report: "Verificar Relatório",
                suspicious_transactions: "Transações Suspeitas",
                train_capacity_graph: "Gráfico de Capacidade do Trem",
                highest_monthly_trains_transactions_graph: "Gráfico de Transações Mensais Mais Altas de Trens",
                highestMonthly_operator_collections_chart: "Gráfico de Colecções Mensais Mais Altas de Operadores",
                bus_tickets_transactions: "Transações de Bilhetes de Ônibus",
                long_train_transactions: "Transações de Trem Longo",
                automotora_transactions: "Transações de Automotora",
                zone_transactions: "Transações de Zona",
                cards_transactions: "Transações de Cartões",
                cargo_transactions: "Transações de Carga",
                weekly: "Semanal",
                monthly: "Mensal",
                dashboard: "Painel",
                do_you_really_want_to_complete_this_action: "Você realmente quer completar esta ação?",
                do_you_really_want_to_delete_this_record: "Você realmente quer deletar este registro?",
                select_coach: "Selecionar Vagão",
                new_coach: "Novo Vagão",
                coach_total_seats: "Total de Assentos do Vagão",
                coach_serial_number: "Número de Série do Vagão",
                add_coach: "Adicionar Vagão",
                coach_details: "Detalhes do Vagão",
                train_total_seats: "Total de Assentos do Trem",
                dest_time: "Hora Dest",
                dest_station: "Estação Dest",
                all_today_trains: "Todos os Trens de Hoje",
                today_trains: "Trens de Hoje",
                are_you_sure: "Você tem certeza?",
                new_balance: "Novo Saldo",
                adjustment_details: "Detalhes do Ajuste",
                initiator_name: "Nome do Iniciador",
                approval_level: "Níveis de Aprovação",
                current_user: "Usuário Atual",
                credit_top_up: "Crédito de Recarga",
                select_account_number: "Selecionar Número da Conta",
                balance_adjustment: "Ajuste de Saldo",
                choose_company: "Escolher Empresa",
                choose_card_ownership: "Escolher Propriedade do Cartão",
                card_ownership: "Propriedade do Cartão",
                card_status: "Status do Cartão",
                linked_customer_details: "Detalhes do Cliente Vinculado",
                choose_card_status: "Escolher Status do Cartão",
                edit_card: "Editar Cartão",
                choose_file: "Escolher Arquivo",
                card_template: "Modelo de Cartão",
                new_cards_file: "Novo arquivo de cartões",
                normal_cards: "Cartões normais",
                employee_cards: "Cartões de Funcionário",
                choose_card_type: "Escolher Tipo de Cartão",
                you_need_permission: "Você precisa de permissão: ",
                upload_new_ards: "Carregar Novos Cartões",
                permissions: "Permissões",
                upload_new_cards: "Carregar Novos Cartões",
                individual: "Individual",
                last_five_digits: "Últimos Cinco Dígitos",
                edit_employee_incentive: "Editar Incentivo ao Funcionário",
                debit_on: "Débito em",
                new_account_package: "Novo Pacote de Conta",
                validity_type: "Tipo de Validade",
                send_to_device: "Enviar para Dispositivos",
                usage_type: "Tipo de Uso",
                debit_field_type: "Tipo de Campo de Débito",
                trips_per_day: "Viagens por dia",
                trips_per_month: "Viagens por mês",
                max_balance: "Saldo Máximo",
                package_trip_validity_days: "Validade do Pacote de Viagens (Dias)",
                package_maximum_balance: "Saldo Máximo do Pacote",
                package_minimum_balance: "Saldo Mínimo do Pacote",
                package_for_sale: "Pacote para Venda",
                package_details: "Detalhes do Pacote",
                send_to_devices: "Enviar para Dispositivos",
                package_valid: "Pacote Válido",
                is_package_for_sale: "O Pacote é para Venda",
                min_balance: "Saldo Mínimo",
                discount_percent: "Percentagem de Desconto",
                check_account_balance: "Verificar saldo da conta",
                check_date_expiry: "Verificar data de expiração",
                check_trip_balance: "Verificar saldo de viagens",
                internal: "Interno",
                customer: "Cliente",
                dept_on: "Dept On",
                trip_per_day: "Viagem por dia",
                trip_per_month: "Viagem por mês",
                validation_type: "Tipo de Validação",
                package_discription: "Descrição do Pacote",
                edit_account_package: "Editar Pacote de Conta",
                account_packages: "Pacotes de Conta",
                account_package: "Pacote de Conta",
                expired_date: "Data de Expiração",
                fax_number: "Número de Fax",
                add_contract_company: "Adicionar Empresa do Contrato",
                edit_contract_company: "Editar Empresa do Contrato",
                pay_type: "Tipo de Pagamento",
                limit_amount: "Montante do Limite",
                contract_validity: "Validade do Contrato",
                special_discount: "Desconto Especial",
                vat_number: "Número de IVA",
                tax_number: "Número de Contribuinte",
                postal_address: "Endereço Postal",
                postal_code: "Código Postal",
                physical_address: "Endereço Físico",
                registered_name: "Nome Registrado",
                registered_number: "Número Registrado",
                contract_number: "Número do Contrato",
                institution_name: "Nome da Instituição",
                contact_person_name: "Nome da Pessoa de Contacto",
                contact_person_email: "Email da Pessoa de Contacto",
                contact_person_phone: "Telefone da Pessoa de Contacto",
                view_contract_company: "Ver Empresa do Contrato",
                add_new: "Adicionar Novo",
                account_card_statement: "Extrato da Conta do Cartão",
                edit_account_details: "Editar Detalhes da Conta",
                account_balance: "Saldo da Conta",
                count_balance: "Saldo da Conta",
                account_usage_type: "Tipo de Uso da Conta",
                customer_accounts: "Contas de Clientes",
                accounts_blocked: "Contas Bloqueadas",
                choose_gender: "Escolher Gênero",
                identification_image: "Imagem de Identificação",
                passport_image: "Imagem do Passaporte",
                edit_customer_details: "Editar Detalhes do Cliente",
                active_cards: "Cartões Ativos",
                inactive_cards: "Cartões Inativos",
                blocked_cards: "Cartões Bloqueados",
                expired_cards: "Cartões Expirados",
                all_cards: "Todos os Cartões",
                package_trips: "Pacotes de viagens",
                package_trips_balance: "Saldo de Pacotes de Viagens",
                uploded_date: "Data de upload",
                middle_name: "Nome do Meio",
                identification_number: "Número de Identificação",
                card_details: "Detalhes do Cartão",
                card_view: "Vista do Cartão",
                first_name: "Primeiro Nome",
                last_name: "Último Nome",
                registration_date: "Data de Registro",
                assign_card: "Atribuir Cartão",
                reassign_card: "Reatribuir Cartão",
                customer_details: "Detalhes do Cliente",
                transaction_status: "Status da Transação",
                sent: "Enviado",
                pending: "Pendente",
                phc_ticket_code: "Código do Bilhete PHC",
                cancel_date: "Data de Cancelamento",
                cancel_reason: "Motivo do Cancelamento",
                fine_amount: "Montante da Multa",
                transaction_amount: "Montante da Transação",
                view_card: "Ver Cartão",
                from_old: "De (Antigo)",
                sequence_number: "Número de Sequência",
                transaction_action: "Ação de Transação",
                transaction_type: "Tipo de Transação",
                approval_logs: "Registos de Aprovação",
                process_flow_actors: "Atores do Fluxo de Processo",
                last_user_comment: "Último Comentário do Usuário",
                transaction_details: "Detalhes da Transação",
                approval_details: "Detalhes da Aprovação",
                approval_process_details: "Detalhes do Processo de Aprovação",
                no_transaction_details_related_to_this_approval: "Nenhum detalhe de transação relacionado a esta aprovação!",
                start_date: "Data de Início",
                end_date: "Data de Fim",
                transaction_types: "Tipos de Transação",
                adjustment_types: "Tipos de Ajuste",
                transaction_sources: "Fontes de Transação",
                transaction_statuses: "Status da Transação",
                train_types: "Tipos de Comboios",
                cfm_classes: "Classes CFM",
                allowed_sales: "Vendas Permitidas",
                balance_vendor_id: "ID do Vendedor do Saldo",
                balance_product_id: "ID do Produto de Saldo",
                add_operator_allocation: "Adicionar Alocação de Operador",
                on_off_train: "ON-OFF TREM",
                printer_bda: "Impressora BDA",
                reset_password: "Redefinir senha",
                id_number: "Número de Identificação",
                operator_details: "Detalhes do Operador",
                incentives_booking: "Reserva de Incentivos",
                zone_train_sales: "Vendas de Comboios de Zona",
                normal_train_sales: "Vendas Normais de Comboios",
                automotora_train_sales: "Vendas de Comboios Automotora",
                changing_class: "Mudança de Classe",
                top_up: "Carregamento",
                registration: "Registro",
                scan_qr: "Escanear QR",
                operator_email: "Email do Operador",
                agent_number: "Número do Agente",
                user_name: "Nome de usuário",
                start_selling: 'Hora de abertura das vendas',
                end_selling: 'Hora de fim de venda',
                top_up_collection: 'Recolha de Carregamentos',
                device_summary: 'Resumo do Dispositivo',
                system_summary: 'Resumo do Systema',
                male: "masculino",
                female: "feminino",
                backHome: "Voltar para o início",
                forbidden: "Não tem permissão suficiente para esta tarefa.",
                TransactionType: "Tipo de Transa",
                train_number: "Número do comboio",
                total_seats: "Total de assentos",
                language: "Portuguese",
                change_status: "Alterar Status",
                greeting: "Wooza",
                cargo: "carga",
                transaction: "transação",
                transactions: "Transações",
                all: "todos",
                showing: "mostrando",
                search: "pesquisa",
                of: "de",
                previous: "anterior",
                next: "próximo",
                current: "atual",
                page: "página",
                operator: "operador",
                operators: "operadors",
                name: "Nome",
                total: "total",
                amount: "quantia",
                weight: "peso",
                sender: "remetente",
                details: "detalhes",
                receiver: "receber",
                from: "de",
                to: "para",
                statuses: "status",
                action: "Ação",
                method: "método",
                ip_address: "endereço IP",
                endpoint: "ponto final",
                username: "nome de usuário",
                activity: "atividade",
                audit: "auditoria",
                trail: "trilha",
                trails: "trilhas",
                user: "do utilizador",
                actor: "ator",
                actors: "atores",
                browser: "navegador",
                date: "Data",
                add: "adicionar",
                category: "categoria",
                categories: "categorias",
                sub_category: "subcategoria",
                sub_categories: "subcategorias",
                are: "sã",
                you: "você",
                sure: "clara",
                do_you_really_want_to: "você realmente quer",
                delete: "excluir",
                confirm: "confirme",
                submit: "enviar",
                cancel: "cancelar",
                tracking: "monitorando",
                this: "esse",
                record: "registro",
                next_status_name: "próximo status nome",
                receipt_number: "número do recibo",
                reference_number: "número de referência",
                purchase: "comprar",
                phone: "telefone",
                number: "número",
                price: "preço",
                measurement: "medição",
                kg: "kg",
                meticals: "meticais",
                payment: "pagamento",
                shipping: "envio",
                information: "informação",
                info: "informações",
                quantity: "quantidade",
                item: "item",
                order: "ordem",
                print: "imprimir",
                PDF: "PDF",
                export: "exportar",
                device: "dispositivo",
                ID: "Identidade",
                serial: "serial",
                model: "modelo",
                type: "tipo",
                types: "tipos",
                zones: "zonas",
                zone: "zona",
                sources: "fontes",
                manufacture: "fabricação",
                manufactures: "fabrica",
                wagon: "vagão",
                wagons: "vagões",
                seat: "assento",
                seats: "assentos",
                configuration: "configuração",
                configurations: "configurações",
                standing: "de pé",
                train: "comboio",
                trains: "Comboios",
                class: "aula",
                classes: "aulas",
                select: "selecione",
                normal: "normal",
                cabin: "cabine",
                cabins: "cabines",
                label: "rótulo",
                serial_number: "número de série",
                wagon_type: "tipo de vagão",
                layout: "layout",
                layouts: "layouts",
                completo: "completo",
                criteria: "critério",
                criterias: "critérios",
                report: "relatório",
                module: "módulo",
                aisle: "aisle",
                rows: "linhas",
                row: "linha",
                columns: "colunas",
                column: "coluna",
                incentives: "incentivas",
                mode: "modo",
                rate: "avaliar",
                flat_amount: "quantia fixa",
                percentage: "percentagem",
                summary: "resumo",
                tickets: "ingressos",
                ticket: "bilhete",
                collected: "coletada",
                time: "tempo",
                on_train: "no trem",
                off_train: "Offtrain",
                file: "arquivo",
                excel: "Excel",
                csv: "CSV",
                txt: "txt",
                notifications: "notificações",
                profile: "perfil",
                reset: "reiniciar",
                password: "senha",
                help: "ajuda",
                logout: "sair",
                cash: "dinheiro",
                ascending: "ascendente",
                asc: "asc",
                desc: "desc",
                descending: "descendente",
                count: "contar",
                top: "principal",
                up: "acima",
                collection: "coleção",
                start: "começar",
                end: "fim",
                for: "para",
                uncollected: "não coletado",
                approval: "aprovação",
                processes: "processos",
                approve: "Aprovar",
                approved: "Aprovada",
                reject: "Rejeitar",
                rejected: "rejeitado",
                on_progress: "em progresso",
                on: "sobre",
                level: "nível",
                created_at: "criado em",
                updated_at: "atualizado em",
                initiator: "iniciador",
                last: "durar",
                process: "processo",
                comment: "comente",
                logs: "histórica",
                received: "recebida",
                manual: "manual",
                slots: "slots",
                coaches: "treinadoras",
                coach: "treinadora",
                schedule: "agendar",
                schedules: "horários",
                departure: "partida",
                destination: "destino",
                station: "estação",
                stations: "estações",
                dep: "dep",
                dest: "dest",
                day_of_the_week: "dia da semana",
                trip_duration_hours: "horas de duração da viagem",
                monday: "segunda-feira",
                tuesday: "terça-feira",
                wednesday: "quarta-feira",
                thursday: "quinta-feira",
                friday: "sexta-feira",
                saturday: "sábado",
                sunday: "domingo",
                day: "dia",
                days: "dias",
                edit: "editar",
                today: "hoje",
                the: "o",
                week: "semana",
                new: "nova",
                paid: "paga",
                list: "lista",
                arrangement: "arranjo",
                hours: "horas",
                system: "Sistema",
                physical: "física",
                any: "qualquer",
                print_out: "imprimir",
                active: "Ativo",
                inactive: "inativo",
                full: "completo",
                contact: "Contato",
                blocked: "bloqueado",
                users: "users",
                line: "linha",
                lines: "linhas",
                customers: "Clientes",
                km: "km",
                range: "faixa",
                prices: "preços",
                upload: "carregar",
                assign: "atribuir",
                reassign: "reatribuir",
                actions: "actions",
                account: "conta",
                accounts: "contas",
                contacts: "Contatos",
                news: "notícias",
                updates: "atualizações",
                content: "contente",
                platform: "plataforma",
                title: "título",
                POS: "POS",
                kiosk: "kiosk",
                application: "aplicativa",
                flow: "flow",
                sequence: "sequência",
                route: "Rota",
                old: "old",
                card: "card",
                cards: "cards",
                ownership: "propriedade",
                owner: "proprietária",
                expire: "expirar",
                uploded: "carregada",
                package: "package",
                trips: "viagens",
                gender: "gênero",
                identification: "identification",
                primeira: "primeira",
                meio: "meio",
                usage: "usage",
                code: "código",
                balance: "saldo",
                minimum: "mínimo",
                sale: "venda",
                send: "enviar",
                per: "por",
                debit: "débito",
                field: "campo",
                discount: "desconto",
                group: "grupo",
                special: "especial",
                main: "principal",
                expired: "expirado",
                five: "cinco",
                digits: "digitos",
                arrival: "chegada",
                direction: "direcao",
                support: "suporte",
                second: "segundo",
                third: "terceiro",
                one: "um",
                two: "dois",
                three: "tres",
                reverse: "reverso",
                reason: "motivo",
                fine: "multa",
                change: "alterar",
                receipt: "recibo",
                charge: "cobranca",
                valid: "valido",
                failed: "falhou",
                phc: "phc",
                back: "voltar",
                cancelled_at: "Cancelado em",
                validation_status: "Status de Validacao",
                validator: "Validador",
                contract: "contrato",
                institution: "instituicao",
                packages: "pacotes",
                no_train_details: "Sem detalhes do trem",
                top_up_transaction: "transacao de recarga",
                cancellation: "cancelamento",
                suspicious: "suspeito",
                adjustment: "ajuste",
                credit: "credito",
                adjustment_transaction_type: "Ajuste de Saldo (CR / DR)",
                no_customer_record: "Nenhum registro de cliente",
                cancel_multiple_transactions: "Cancelar multiplas transacoes",
                no: "nao",
                email: "Email",
                choose: "escolher",

                // Not translate
                passport: "passport",
                message: "message",
                pin: "pin",
                routes: "routes",
                description: "descrição",
                trend: "tendência",
                employee_incentive: "Bonuses or extra payments",
                customer_name: "nome do cliente",
                Employee_ID: "ID do funcionário",
                agent: "agente",
                month: "mês",
                menu: {
                    dashboard: "Painel",
                    management: "Configurações",
                    trainClasses: "Classes de Trem",
                    trainLines: "Linhas de Trem",
                    trainRoutes: "Rotas de Trem",
                    stations: "Estações",
                    trains: "Trens",
                    todayTrains: "Trens de Hoje",
                    prices: "Preços",
                    stationSchedules: "Horários das Estações",
                    zones: "Zonas",
                    cardManagement: "Gestão de Cartões",
                    cards: "Cartões",
                    cardStatement: "Extrato do Cartão",
                    balanceAdjustment: "Ajuste de Saldo",
                    adjustmentApproval: "Aprovação de Ajuste",
                    customerManagement: "Gestão de Clientes",
                    customers: "Clientes",
                    customerAccounts: "Contas de Clientes",
                    contractInstitutions: "Instituições Contratadas",
                    accountPackages: "Pacotes de Conta",
                    employeeIncentive: "Incentivo ao Funcionário",
                    transactionManagement: "Gestão de Transações",
                    transactions: "Transações",
                    cancelApproval: "Cancelar Aprovação",
                    adjustmentTransactions: "Transações de Ajuste",
                    devices: "Dispositivos",
                    validation: "Validação",
                    suspiciousReport: "Relatório Suspeito",
                    trainCapacity: "Capacidade do Trem",
                    collections: "Coletas",
                    collectionApproval: "Aprovação de Coleta",
                    operatorAccounts: "Contas de Operadores",
                    m10Summary: "Resumo M10",
                    cargo: "Carga",
                    cargoCustomers: "Clientes",
                    cargoTransactions: "Transações de Carga",
                    cargoConfigurations: "Configurações de Carga",
                    cargoPrices: "Preços de Carga",
                    reports: "Relatórios",
                    moduleReports: "Relatórios de Módulos",
                    users: "Usuários",
                    systemUsers: "Usuários do Sistema",
                    rolesPermissions: "Funções e Permissões",
                    trainSchedules: "Horários dos Trens",
                    trainSetup: "Configuração do Trem",
                    coachManufactures: "Fabricantes de Vagões",
                    coachLayouts: "Layouts de Vagões",
                    coaches: "Vagões",
                    trainLayouts: "Layouts de Trem",
                    settings: "Configurações",
                    specialGroup: "Grupo Especial",
                    incentiveConfigurations: "Configurações de Incentivo",
                    newsUpdates: "Notícias e Atualizações",
                    cfmInformation: "Informações da CFM",
                    auditTrail: "Trilha de Auditoria",
                    deviceSummaryReport: "Relatório de Dispositivos",
                    train_penalty: "Penalização de comboio",
                },
                latest_report_request: "Última solicitação de relatório",
                report_request: "Solicitação de relatório",
                report_request_history: "Histórico de solicitações de relatório",
                cargo_customers: "Clientes de carga",
                active_customers: "Clientes ativos",
                inactive_customers: "Clientes inativos",
                operator_collection: "Coleção do Operador",
                top_up_collections: "Coleções de recarga",
                train_collections: "Coleções de trens",
                all_collections: "Todas as coleções",
                history: "Histórico",
                sys_amount: "Quantia do sistema",
                sys_tickets: "Ingressos do sistema",
                summary_amount: "Quantia resumida",
                asc_data: "Dados Asc",
                created_date: "Data de criação",
                total_number: "Número Total",
                date_time: "Data e Hora",
                suspicious_report: "Relatório Suspeito",
                operator_name: "Nome do Operador",
                operator_id: "ID do Operador",
                device_id: "ID do Dispositivo",
                device_serial: "Serial do Dispositivo",
                total_tickets: "Total de Ingressos",
                total_amount: "Quantia Total",
                report_status: "Status do Relatório",
                location: "Localização",
                ticket_no: "Número do Ingresso",
                device_management: "Gestão de Dispositivos",
                operator_allocation: "Alocação de Operadores",
                device_operator: "Operador do Dispositivo",
                device_name: "Nome do Dispositivo",
                version: "Versão",
                app_version: "Versão da Aplicação",
                base_station: "Estação Base",
                code_number: "Número do Código",
                add_new_device: "Adicionar Novo Dispositivo",
                reference_no: "Número de Referência",
                add_new_customer: "Adicionar Novo Cliente",
                category_name: "Nome da Categoria",
                card_number: "Número do Cartão",
                is_employee: "É Funcionário",
                registered_date: "Data de Registro",
                full_name: "Nome Completo",
                package_code: "Código do Pacote",
                account_type: "Tipo de Conta",
                contact_person: "Pessoa de Contato",
                expire_date: "Data de Expiração",
                org_name: "Nome da Organização",
                package_name: "Nome do Pacote",
                package_description: "Descrição do Pacote",
                package_amount: "Quantia do Pacote",
                package_usage: "Uso do Pacote",
                employee_id: "ID do Funcionário",
                status: "Estado",
                account_number: "Número da conta",
                rejected_approval_processes: "Processos de Aprovação Rejeitados",
                approved_approval_processes: "Processos de Aprovação Aprovados",
                on_progress_approval_processes: "Processos de Aprovação em Andamento",
                train_lines: "Linhas de Trem",
                line_distance_km: "Distância da Linha (KM)",
                cfm_region: "Região CFM",
                train_line: "Linha de Trem",
                train_routes: "Rotas de Trem",
                train_route: "Rota de Trem",
                route_name: "Nome da Rota",
                line_name: "Nome da Linha",
                add_train_route: "Adicionar Rota de Trem",
                add_new_train_route: "Adicionar Nova Rota de Trem",
                start_station: "Estação de Início",
                end_station: "Estação Final",
                choose_start_station: "Escolher Estação de Início",
                choose_end_station: "Escolher Estação Final",
                choose_destination_station: "Escolher Estação de Destino",
                destination_station: "Estação de Destino",
                departure_station: "Estação de Partida",
                choose_line_name: "Escolher Nome da Linha",
                choose_route_name: "Escolher Nome da Rota",
                add_train: "Adicionar Trem",
                train_type: "Tipo de Trem",
                add_new_train: "Adicionar Novo Trem",
                train_name: "Nome do Trem",
                train_status: "Status do Trem",
                travel_hours_duration: "Duração das Horas de Viagem",
                zone_price_group: "Grupo de Preço da Zona",
                train_first_class: "Primeira Classe do Trem",
                first_class: "Primeira Classe",
                second_class: "Segunda Classe",
                third_class: "Terceira Classe",
                choose_train_type: "Escolher Tipo de Trem",
                choose_train_status: "Escolher Status do Trem",
                choose_zone_price_group: "Escolher Grupo de Preço da Zona",
                select_train_line: "Selecionar Linha de Trem",
                select_train_route: "Selecionar Rota de Trem",
                select_origin_station: "Selecionar Estação de Origem",
                select_destination_station: "Selecionar Estação de Destino",
                select_start_station: "Selecionar Estação de Início",
                select_end_station: "Selecionar Estação Final",
                select_coach_layout: "Selecionar Layout do Vagão",
                select_wagon_type: "Selecionar Tipo de Vagão",
                coach_layout: "Layout do Vagão",
                add_new_train_station: "Adicionar nova estação de trem",
                train_stations: "Estações Ferroviárias",
                station_name: "Nome da estação",
                distance_maputo: "Distância Maputo",
                add_train_station: "Adicionar Estação de Trem",
                initial_station_name: "Nome da Estação Inicial",
                distance_from_main_station: "Distância da Estação Principal",
                select_ascending_zone: "Selecionar Zona Ascendente",
                select_descending_zone: "Selecionar Zona Descendente",
                off_train_ticket_available: "BILHETE FORA DO TREM DISPONÍVEL",
                add_new_zone_price: "Adicionar Novo Preço de Zona",
                zone_price: "Preço da Zona",
                zone_i: "Zona I",
                zone_ii: "Zona II",
                zone_iii: "Zona III",
                zone_iv: "Zona IV",
                automotora_price: "Preço da Automotora",
                normal_price: "Preço Normal",
                zone_prices: "Preços de Zona",
                zone_name: "Nome da Zona",
                fare_cost: "Custo da Tarifa (MT)",
                on_train_cost: "Custo no Trem (MT)",
                add_zone_price: "Adicionar Preço de Zona",
                select_class: "Selecionar Classe",
                special_group: "Grupo Especial",
                select_special_group: "Selecionar Grupo Especial",
                import_excel: "Importar Excel",
                choose_excel_file: "Escolher Ficheiro Excel",
                download_template: "Descarregar Modelo",
                select_line_first: "Selecione primeiro uma linha",
                import_processing: "A processar o seu ficheiro…",
                import_processing_hint: "Isto pode demorar alguns minutos para ficheiros grandes — pode sair desta página, o progresso está seguro.",
                import_failed: "Falha na importação",
                try_again: "Tentar Novamente",
                import_results: "Resultados da Importação",
                rows_created: "Linhas Criadas",
                rows_updated: "Linhas Atualizadas",
                rows_skipped: "Linhas Ignoradas",
                select_train_group: "Selecionar Grupo de Trem",
                off_train_cost: "Custo Fora do Trem (MT)",
                report_history: "Histórico de Relatórios",
                report_name: "Nome do Relatório",
                from_date: "Data de Início",
                to_date: "Data Final",
                file_type: "Tipo de Arquivo",
                created_by: "Criado Por",
                all_customers: "Todos os Clientes",
                other: "Outro",
                phone_number: "Número de Telefone",
                customer_type: "Tipo de Cliente",
                select_customer_type: "Selecionar Tipo de Cliente",
                payment_mode: "Modo de Pagamento",
                customer_service_type: "Tipo de Serviço ao Cliente",
                select_payment_mode: "Selecionar Modo de Pagamento",
                add_customer: "Adicionar Cliente",
                company_registration_number: "Número de Registro da Empresa",
                add_category: "Adicionar Categoria",
                "pay": "pagar",
                "tax": "imposto",
                "service": "serviço",
                "address": "endereço",
                "imei": "imei",
                "last_connect": "última Conexão",
                collected_amount: "Quantia Coletada",
                total_transactions: "Total de Transações",
                ascend_train: "Trem Ascendente",
                des_system_amount: "Quantia do Sistema Des",
                des_system_tickets: "Ingressos do Sistema Des",
                asc_system_amount: "Quantia do Sistema Asc",
                asc_system_tickets: "Ingressos do Sistema Asc",
                descend_train: "Trem Descendente",
                train_Collections: "Coleções de Trem",
                current_page: "Página Atual",
                incentive: "Incentivo",
                train_capacity_report: "Relatório de Capacidade do Trem",
                train_capacity: "Capacidade do Trem",
                edit_device: "Editar Dispositivo",
                device_type: "Tipo de Dispositivo",
                select_device_type: "Selecionar Tipo de Dispositivo",
                select_device_status: "Selecionar Status do Dispositivo",
                device_status: "Status do Dispositivo",
                working: "funcionando",
                on_off_rain: "LIGAR-DESLIGAR TREM",
                application_version: "Versão do Aplicativo",
                device_operators: "Operadores de Dispositivo",
                add_new_device_operator: "Adicionar Novo Operador de Dispositivo",
                select_device_operator: "Selecionar Operador de Dispositivo",
                operator_phone: "Telefone do Operador",
                operator_category: "Categoria do Operador",
                operator_allocations: "Alocações de Operadores",
                add_new_operator_allocation: "Adicionar Nova Alocação de Operador",
                normal_seats: "Assentos Normais",
                standing_slots: "Vagas em Pé",
                total_given: "Total Dado",
                choose_operator: "Escolha o Operador",
                edit_operator_allocation_details: "Editar Detalhes de Alocação do Operador",
                save: "Salvar",
                edit_device_operator: "Editar Operador de Dispositivo",
                device_imei: "Device IMEI",
                transaction_with_penalty_and_fine: "Transação com Multa e Penalidade",
                train_layout: "Layout do Trem",
                compatment: "Compartimento",
                number_of_seat: "Número de Assentos",
                number_of_cabin: "Número de Cabines",
                number_of_compatment: "Número de Compartimentos",
                edit_train_layout: "Editar Layout do Trem",


            }
        },
    }
});

export default i18n;

